import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { VenueId } from '../../venues/venues.types';

export interface VenueState {
    selectedVenue: VenueId | null;
}

export const VENUE_STORAGE_KEY = 'selectedVenue';

const initialState: VenueState = {
    selectedVenue: (localStorage.getItem(VENUE_STORAGE_KEY) as VenueId | null) ?? null,
};

const venueSlice = createSlice({
    name: 'venue',
    initialState,
    reducers: {
        setVenue(state, action: PayloadAction<VenueId>) {
            localStorage.setItem(VENUE_STORAGE_KEY, action.payload);
            state.selectedVenue = action.payload;
        },
        clearVenue(state) {
            localStorage.removeItem(VENUE_STORAGE_KEY);
            state.selectedVenue = null;
        },
    },
});

export const { setVenue, clearVenue } = venueSlice.actions;

export default venueSlice.reducer;
